<template lang='pug' src='./free-orthodontic-consultation.pug'></template>

<script>
import Form from 'components/form/form'

export default {
  computed: {
    props () {
      return this.$store.state.pages['free-orthodontic-consultation']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Form
  }
}
</script>



// WEBPACK FOOTER //
// free-orthodontic-consultation.vue?5ab3f8b0